import { CSSProperties, Fragment, useEffect, useState } from "react";
import ConnectionsCampaignView from "./CampaignViews/ConnectionsCampaignView";
import FinalizationCampaignView from "./CampaignViews/FinalizationCampaignView";
import LinkSelectorCampaignView from "./CampaignViews/LinkSelectorCampaignView";
import useCampaignBuilder, { CURRENT_DATE_SELECTION_TABS } from "Hooks/useCampaignBuilder";
import Colors from "modules/Colors";
import ButtonSymphony from "../elements/ButtonSymphony";
import { clsx, makeKey, styx } from "modules/Utils";
import TabsSymphony, { TabItem } from "elements/TabsSymphony";
import TabSymphony from "elements/TabSymphony";
import DebugBox from "./shareable/DebugBox";
import DatesCampaign from "./CampaignViews/DatesCampaign";
import BudgetSelector from "./CampaignViews/BudgetSelector";
import AdCallToActionSelectorCampaign from "./CampaignViews/AdCallToActionSelectorCampaign";
import {
    PlaybookType,
    PlaybookStepName,
    TOP_BAR_HEADER_FOOTER_HEIGHT,
    WEBSITE_TOP_BAR_HEIGHT_MOBILE,
    PREV_NEXT_FOOTER_HEIGHT_MOBILE,
    TOP_BAR_HEADER_FOOTER_HEIGHT_MOBILE,
    PLAYBOOK_TYPE_INFO,
    AdPlatform
} from 'modules/Const';
import { Playbook, PlaybookStep } from "modules/Types";
import useScreen from "Hooks/useScreen";
import RecordSelectorView from "./CampaignViews/RecordSelectorView";
import GoalSelector, { GOAL_SELECTOR_GOAL_OPTIONS, CAMPAIGN_GOAL } from "./CampaignViews/GoalSelector";
import ConnectionsCampaignView_RIGHT from "./CampaignViews/ConnectionsCampaignView_RIGHT";
import AdCreativeSelectorCampaign from "./CampaignViews/AdCreativeSelectorCampaignView";
import AdPreviewCampaignView from "./CampaignViews/AdPreviewCampaignView";
import TopBar from "./shareable/TopBar/TopBar";
import { useHistory } from "react-router-dom";
import Sty from "modules/Sty";
import ModalSymphony from "../elements/ModalSymphony";
import CreativeTabConnectionDetails_LEFT from "./connect/CreativeTabConnectionDetails_LEFT";
import AdCaptionsSelector from "./CampaignViews/AdCaptionsSelector";
import PlatformsCampaign from "./CampaignViews/PlatformsCampaign";
import PrevNextFooter from "elements/PrevNextFooter";
import useFacebookConnections from "Hooks/useFacebookConnections";
import SuccessCampaign from "./CampaignViews/SuccessCampaign";
import PageSymphony from "elements/PageSymphony";
import RunningForCard from "./CampaignViews/RunningForCard";
import SubmitOrCheckoutButtonsView from "./CampaignViews/SubmitOrCheckoutButtonsView";
import { PlaybookTypeInfoWithPlaybookSteps } from "modules/Campaign";
import { TargetingCampaignViewSummary } from "./CampaignViews/TargetingCampaignViewSummary";

const CAMPAIGN_VIEW_MAX_WIDTH = 680;
const SIDE_CONTENT_WIDTH = 300;
const CAMPAIGN_VIEW_BOTTOM_BAR_HEIGHT = 72;
const CAMPAIGN_VIEW_EXTRA_MODAL_HEIGHT = 40;
const RECORD_SELECTOR_HEIGHT = 373;
const RECORD_SELECTOR_HEIGHT_MOBILE = 284;

interface CampaignViewProps {
    className: string;
    /** Initial step to show when component mounts */
    defaultStep?: PlaybookStepName;
    /** Whether to default to the last step when loading from a draft */
    defaultsToLastStep?: boolean;
    /** Whether to default to the first step when loading from a draft */
    defaultsToFirstStep?: boolean;
}

const CampaignView = ({
    className,
    defaultStep,
    defaultsToLastStep = false,
    defaultsToFirstStep = true,
}: CampaignViewProps) => {
    const history = useHistory();
    const { cssCalc, mStyle, mobileView } = useScreen();
    const {
        currentStep,
        setCurrentStep,
        campaignInitialized,
        playbookType,
        playbookStepNames,
        setPlaybookStepNames,
        nextCampaignStep,
        prevCampaignStep,
        selectedSongToPromote,
        linksToPromote,
        expressSetupOrCustomPages,
        resetCampaignState,
        isLoadingCampaign,

        // NOTE: vars for validation and next step
        budget,
        budgetMaximum,
        currentDateSelectionTab,
        numberOfDays,
        startDate,
        endDate,
        adPlatform,
        getAllSelectedPosts,
        campaignGoal,
        isBudgetTooLow,
        isGeographyBucketsObjectValid,
    } = useCampaignBuilder();

    const {
        canRunAds,
    } = useFacebookConnections()

    // const isShowMeHowButtonHeight = isShowMeHowButton() ? CAMPAIGN_VIEW_EXTRA_MODAL_HEIGHT : 0;
    // const headerAndFooterHeight = mobileView ?  // TODO CONNER: leave this, i will make it better
    //     TOP_BAR_HEADER_FOOTER_HEIGHT + isShowMeHowButtonHeight
    //     :
    //     TOP_BAR_HEADER_FOOTER_HEIGHT;

    const [isShowRightSideContentModal, setIsShowRightSideContentModal] = useState<boolean>(false);
    const [playbookInitialized, setPlaybookInitialized] = useState<boolean>(false);

    const PLAYBOOK_TYPE_INFO_WITH_PLAYBOOK_STEPS: PlaybookTypeInfoWithPlaybookSteps[] = [
        {
            ...PLAYBOOK_TYPE_INFO[PlaybookType.INCREASE_MUSIC_STREAMS],
            entryPoint: {
                title: PlaybookStepName.RECORD_SELECTOR,
                name: PlaybookStepName.RECORD_SELECTOR,
                middleContent: [
                    <RecordSelectorView
                        className="recordSelectorViewCampaignView2_IncreaseMusicStreams"
                        cssCalcHeight={mobileView ? RECORD_SELECTOR_HEIGHT_MOBILE : RECORD_SELECTOR_HEIGHT}
                    />
                ]
            },
            connectionsMiddleContent: [
                <ConnectionsCampaignView
                    className="campaignConnectionsDetails_IncreaseMusicStreams"
                    variant="facebook"
                    allowExpressSetup={false}
                />
            ],
            creativeMiddleContent: [
                <AdCreativeSelectorCampaign
                    className="adCreativeSelectorCampaign_IncreaseMusicStreams"
                    variant="facebook"
                />,
                <AdCaptionsSelector
                    className="adCaptionsSelectorCampaign_IncreaseMusicStreams"
                />,
                <AdCallToActionSelectorCampaign
                    className="adCallToActionSelectorCampaign_IncreaseMusicStreams"
                    variant="facebook"
                />,
                <PlatformsCampaign
                    className="platformsCampaign_IncreaseMusicStreams"
                />,
            ]
        },
        {
            ...PLAYBOOK_TYPE_INFO[PlaybookType.GROW_PLAYLIST_FOLLOWERS],
            connectionsMiddleContent: [
                <ConnectionsCampaignView
                    className="connectionsCampaignView_GrowPlaylistFollowers"
                    variant="facebook"
                    allowExpressSetup={false}
                />
            ],
            entryPoint: {
                title: PlaybookStepName.RECORD_SELECTOR,
                name: PlaybookStepName.RECORD_SELECTOR,
                middleContent: [
                    <RecordSelectorView
                        options={['playlist']}
                        className="recordSelectorViewCampaignView2_GrowPlaylistFollowers"
                        cssCalcHeight={mobileView ? RECORD_SELECTOR_HEIGHT_MOBILE : RECORD_SELECTOR_HEIGHT}
                    />
                ]
            },
            creativeMiddleContent: [
                <AdCreativeSelectorCampaign variant="facebook" className="adCreativeSelectorCampaign_GrowPlaylistFollowers" />,
                <PlatformsCampaign
                    className="platformsCampaign_GrowPlaylistFollowers"
                />,
                <AdCallToActionSelectorCampaign
                    variant="facebook"
                    className="adCallToActionSelectorCampaign_GrowPlaylistFollowers"
                />,
                <AdCaptionsSelector
                    className="adCaptionsSelector_GrowPlaylistFollowers"
                />,
            ]
        },
        {
            ...PLAYBOOK_TYPE_INFO[PlaybookType.META_PRESAVES],
            entryPoint: {
                name: PlaybookStepName.LINK_SELECTOR,
                title: 'Link Selector',
                middleContent: [
                    <LinkSelectorCampaignView
                        className="linkSelectorViewCampaignView_Presaves"
                        title={PLAYBOOK_TYPE_INFO[PlaybookType.META_PRESAVES].linkSelectorTitle}
                        subtitle={PLAYBOOK_TYPE_INFO[PlaybookType.META_PRESAVES].linkSelectorSubtitle}
                        placeholder="https://symphony.to/presave"
                    />
                ]
            },
        },
        {
            ...PLAYBOOK_TYPE_INFO[PlaybookType.META_IG_SOUND],
            entryPoint: {
                name: PlaybookStepName.LINK_SELECTOR,
                title: 'Link Selector',
                middleContent: [
                    <LinkSelectorCampaignView
                        className="linkSelectorViewCampaignView_IGSound"
                        title={PLAYBOOK_TYPE_INFO[PlaybookType.META_IG_SOUND].linkSelectorTitle}
                        subtitle={PLAYBOOK_TYPE_INFO[PlaybookType.META_IG_SOUND].linkSelectorSubtitle}
                        placeholder="https://www.instagram.com/sound"
                    />
                ]
            },
        },
        {
            ...PLAYBOOK_TYPE_INFO[PlaybookType.GET_PLAYLISTED],
        },
        {
            ...PLAYBOOK_TYPE_INFO[PlaybookType.BOOST_INSTAGRAM_ENGAGEMENT],
            entryPoint: {
                title: PlaybookStepName.GOAL_SELECTOR,
                name: PlaybookStepName.GOAL_SELECTOR,
                middleContent: [
                    <GoalSelector // NOTE CONNER & MEGH: this actually get skipped
                        className="goalSelector_BoostInstagramEngagement"
                        goalOptions={[
                            GOAL_SELECTOR_GOAL_OPTIONS[CAMPAIGN_GOAL.BOOST_VIEWS],
                            GOAL_SELECTOR_GOAL_OPTIONS[CAMPAIGN_GOAL.BOOST_PROFILE_VISITS],
                        ]}
                    />
                ]
            }
        },
        {
            ...PLAYBOOK_TYPE_INFO[PlaybookType.TIKTOK_BOOST_ENGAGEMENT],
            entryPoint: {
                title: PlaybookStepName.GOAL_SELECTOR,
                name: PlaybookStepName.GOAL_SELECTOR,
                middleContent: [
                    <GoalSelector
                        className="goalSelector_RunTikTokAds"
                        goalOptions={[
                            {
                                id: "boost_views",
                                icon: 'tiktokViews',
                                label: "Boost TikTok Video Views",
                                subtype: 'video',
                                conversionGoal: "Ads will optimize to boost views and likes on your TikTok video.",
                                description: "Increase views on a TikTok video to boost your overall reach. Best used when your goal is to increase engagement on a specific video.",
                                recommendation: "Ideal for getting cost-effective views on a video, not primarily for growing followers.",
                                tips: "Optimize for cost-effectiveness to maximize views and likes. While not the most efficient for increasing followers, it can significantly extend your reach with sufficient budget.",
                                whenToUse: [
                                    "When you have a TikTok video that you want to push for maximum exposure.",
                                    "Best for getting affordable views on a video, not primarily for growing followers.",
                                    "To boost engagement and potentially trigger the TikTok algorithm for wider organic reach."
                                ],
                                setupNeeded: [
                                    "Access to your TikTok Ads account.",
                                    "A TikTok post to promote."
                                ],
                                conversionType: "view",
                                averageConversionCost: 0.01,
                                available: true,
                            },
                            {
                                id: "boost_profile_visits",
                                icon: 'tiktokVisits',
                                label: "Boost TikTok Profile Visits",
                                subtype: 'profile',
                                conversionGoal: "Ads will optimize to increase profile visits.",
                                description: "Optimize for more visits to your profile, resulting in potentially more followers. Best used when your goal is to increase followers or boost your reach.",
                                recommendation: "Focuses on acquiring high-intent followers likely to engage with your content.",
                                tips: "May be more costly per action but yields followers with a higher chance of engagement. Avoid if your primary goal is to gain cheap views rather than valuable followers.",
                                whenToUse: [
                                    "When looking to grow your TikTok profile with new, high-quality followers.",
                                    "To increase your overall TikTok presence and potential for viral content."
                                ],
                                setupNeeded: [
                                    "Access to your TikTok Ads account.",
                                    "A compelling TikTok video to attract potential followers."
                                ],
                                conversionType: "profile visit",
                                averageConversionCost: 0.20,
                                available: true,
                            }
                        ]}
                    />
                ]
            }
        },
        {
            ...PLAYBOOK_TYPE_INFO[PlaybookType.TIKTOK_EXTERNAL_TRAFFIC],
            entryPoint: {
                name: PlaybookStepName.LINK_SELECTOR,
                title: 'Link Selector',
                middleContent: [
                    <LinkSelectorCampaignView
                        className="linkSelectorViewCampaignView_IncreaseLinkClicksTikTok"
                        title={PLAYBOOK_TYPE_INFO[PlaybookType.TIKTOK_EXTERNAL_TRAFFIC].linkSelectorTitle}
                        subtitle={PLAYBOOK_TYPE_INFO[PlaybookType.TIKTOK_EXTERNAL_TRAFFIC].linkSelectorSubtitle}
                        placeholder="https://www.example.com"
                    />
                ]
            }
        },
        {
            ...PLAYBOOK_TYPE_INFO[PlaybookType.TIKTOK_SOUND],
            entryPoint: {
                title: PlaybookStepName.LINK_SELECTOR,
                name: PlaybookStepName.LINK_SELECTOR,
                middleContent: [
                    <LinkSelectorCampaignView
                        className="linkSelectorViewCampaignView_TikTokSound"
                        title={PLAYBOOK_TYPE_INFO[PlaybookType.TIKTOK_SOUND].linkSelectorTitle}
                        subtitle={PLAYBOOK_TYPE_INFO[PlaybookType.TIKTOK_SOUND].linkSelectorSubtitle}
                        placeholder="https://www.tiktok.com/music/TELESCOPE-7367644844594497553"
                    />
                ]
            }
        },
        {
            ...PLAYBOOK_TYPE_INFO[PlaybookType.TIKTOK_MUSIC_STREAMS],
            entryPoint: {
                title: PlaybookStepName.RECORD_SELECTOR,
                name: PlaybookStepName.RECORD_SELECTOR,
                middleContent: [
                    <RecordSelectorView
                        className="recordSelectorViewCampaignView_GrowSongOrAlbumStreamsTikTok"
                        cssCalcHeight={mobileView ? RECORD_SELECTOR_HEIGHT_MOBILE : RECORD_SELECTOR_HEIGHT}
                        handleSelectRecord={nextCampaignStep}
                    />
                ],
            },
            creativeMiddleContent: [
                <AdCreativeSelectorCampaign
                    className="adCreativeSelectorCampaign_GrowSongOrAlbumStreamsTikTok"
                    variant="tiktok"
                />,
                <AdCaptionsSelector
                    className="adCaptionsSelectorCampaign_GrowSongOrAlbumStreamsTikTok"
                />,
                <PlatformsCampaign
                    className="platformsCampaign_GrowSongOrAlbumStreamsTikTok"
                />,
            ]
        },
        // {
        //     playbookType: PlaybookType.TIKTOK_POST,
        //     title: 'Boost TikTok Post Engagement',
        //     icon: 'tiktok',
        //     subtitle: 'Run ads to boost a TikTok post',
        //     type: PromotableItemTypes.POSTS
        // },
        {
            ...PLAYBOOK_TYPE_INFO[PlaybookType.META_EMAIL_SIGNUPS],
            entryPoint: {
                name: PlaybookStepName.LINK_SELECTOR,
                title: 'Link Selector',
                middleContent: [
                    <LinkSelectorCampaignView
                        className="linkSelectorViewCampaignView_EmailSignups"
                        title={PLAYBOOK_TYPE_INFO[PlaybookType.META_EMAIL_SIGNUPS].linkSelectorTitle}
                        subtitle={PLAYBOOK_TYPE_INFO[PlaybookType.META_EMAIL_SIGNUPS].linkSelectorSubtitle}
                        placeholder="https://www.example.com/email-signup"
                    />
                ]
            },
        },
        {
            ...PLAYBOOK_TYPE_INFO[PlaybookType.META_TICKET_SALES],
            entryPoint: {
                name: PlaybookStepName.LINK_SELECTOR,
                title: 'Link Selector',
                middleContent: [
                    <LinkSelectorCampaignView
                        className="linkSelectorViewCampaignView_Event"
                        title={PLAYBOOK_TYPE_INFO[PlaybookType.META_TICKET_SALES].linkSelectorTitle}
                        subtitle={PLAYBOOK_TYPE_INFO[PlaybookType.META_TICKET_SALES].linkSelectorSubtitle}
                        placeholder="https://ticketmaster.com/xyz"
                    />
                ]
            },
        },
        {
            ...PLAYBOOK_TYPE_INFO[PlaybookType.INCREASE_LINK_CLICKS],
            entryPoint: {
                name: PlaybookStepName.LINK_SELECTOR,
                title: 'Link Selector',
                middleContent: [
                    <LinkSelectorCampaignView
                        className="linkSelectorViewCampaignView_IncreaseLinkClicks"
                        title={PLAYBOOK_TYPE_INFO[PlaybookType.INCREASE_LINK_CLICKS].linkSelectorTitle}
                        subtitle={PLAYBOOK_TYPE_INFO[PlaybookType.INCREASE_LINK_CLICKS].linkSelectorSubtitle}
                        placeholder="https://www.example.com"
                    />
                ]
            },
        },
        {
            ...PLAYBOOK_TYPE_INFO[PlaybookType.INCREASE_VIDEO_VIEWS],
        },
    ];

    const AD_PLATFORM_SHARED_PLAYBOOK_STEPS: Partial<Record<AdPlatform, {
        sharedSteps: PlaybookStep[]
    }>> = {
        [AdPlatform.META]: {
            sharedSteps: [
                {
                    title: PlaybookStepName.CONNECTIONS,
                    name: PlaybookStepName.CONNECTIONS,
                    // leftSideContent: {
                    //     title: 'Connection Steps',
                    //     component: (

                    //     )
                    // },
                    middleContent: [
                        <ConnectionsCampaignView
                            className="connectionsCampaignView_Shared_Facebook"
                            variant="facebook"
                            allowExpressSetup={false}
                        />,

                    ],
                    rightSideContent: {
                        component: <ConnectionsCampaignView_RIGHT
                            className="connectionsCampaignViewRight_Shared_Facebook"
                            variant="facebook"
                        />
                    }
                },
                {
                    title: PlaybookStepName.CREATIVE,
                    name: PlaybookStepName.CREATIVE,
                    isNoBackground: true,
                    leftSideContent: {
                        component: (
                            <CreativeTabConnectionDetails_LEFT
                                className="creativeTabConnectionDetailsLeft_Shared_Facebook"
                                onEditConnections={() => {
                                    setCurrentStep(PlaybookStepName.CONNECTIONS);
                                }}
                            />
                        )
                    },
                    middleContent: [
                        <AdCreativeSelectorCampaign
                            className="adCreativeSelectorCampaign_Shared_Facebook"
                            variant="facebook"
                        />,
                        <AdCaptionsSelector
                            className="adCaptionsSelector_Shared_Facebook"
                        />,
                        <AdCallToActionSelectorCampaign
                            className="adCallToActionSelectorCampaign_Shared_Facebook"
                            variant="facebook"
                        />,
                    ],
                    rightSideContent: {
                        component: <AdPreviewCampaignView
                            className="adPreviewCampaignView_Shared_Facebook"
                            variant="facebook"
                        />
                    }
                },
                {
                    title: PlaybookStepName.BUDGET,
                    name: PlaybookStepName.BUDGET,
                    isNoBackground: true,
                    middleContent: [
                        <>
                            <BudgetSelector
                                className="budgetSelector_Shared_Facebook"
                            />
                            <DatesCampaign
                                className="datesCampaign_Shared_Facebook"
                            />
                            <RunningForCard
                                className="runningForCard_Shared_Facebook"
                                disableMobileButton={false}
                                finishFlow={() => { }}
                                targetingType="all"
                                geographyType="all"
                            />
                        </>
                    ],
                },
                {
                    title: PlaybookStepName.TARGETING,
                    name: PlaybookStepName.TARGETING,
                    isNoBackground: true,
                    middleContent: [
                        <TargetingCampaignViewSummary
                            className="targetingCampaignViewAudiences_Shared_Facebook"
                            platform="facebook"
                        />,
                    ],
                    // rightSideContent: {
                    //     title: "Your ads will target these audiences:",
                    //     component: <TargetingCampaignView_PREVIEW
                    //         className="targetingCampaignViewPreview_Shared"
                    //         platform="facebook"
                    //     />
                    // }
                },
                {
                    title: PlaybookStepName.FINALIZATION,
                    name: PlaybookStepName.FINALIZATION,
                    middleContent: [
                        <FinalizationCampaignView
                            className="finalizationCampaignView_Shared_Facebook"
                        />,
                        <SubmitOrCheckoutButtonsView />
                    ]
                }
            ]
        },
        [AdPlatform.TIKTOK]: {
            sharedSteps: [
                // {
                //     title: PlaybookStepName.CONNECTIONS,
                //     name: PlaybookStepName.CONNECTIONS,
                //     // leftSideContent: {
                //     //     title: 'Connection Steps',
                //     //     component: (

                //     //     )
                //     // },
                //     middleContent: [
                //         <ConnectionsCampaignView
                //             className="connectionsCampaignView_Shared"
                //             variant="tiktok"
                //             allowExpressSetup={true}
                //         />,

                //     ],
                //     rightSideContent: {
                //         component: <ConnectionsCampaignView_RIGHT
                //             className="connectionsCampaignViewRight2_Shared"
                //             variant="tiktok"
                //         />
                //     }
                // },
                {
                    title: PlaybookStepName.CREATIVE,
                    name: PlaybookStepName.CREATIVE,
                    isNoBackground: true,
                    // leftSideContent: {
                    //     component: (
                    //         <CampaignConnectionsDetails
                    //             onEditConnections={() => {
                    //                 setCurrentStep(PlaybookStepName.CONNECTIONS);
                    //             }}
                    //         />
                    //     )
                    // },
                    middleContent: [
                        <AdCreativeSelectorCampaign
                            className="adCreativeSelectorCampaign_Shared_TikTok"
                            variant="tiktok"
                        />,
                        <AdCaptionsSelector
                            className="adCaptionsSelector_Shared_TikTok"
                        />,

                    ],
                    rightSideContent: {
                        component: <AdPreviewCampaignView
                            className="adPreviewCampaignView_Shared_TikTok"
                            variant="tiktok"
                        />
                    }
                },
                {
                    title: PlaybookStepName.BUDGET,
                    name: PlaybookStepName.BUDGET,
                    isNoBackground: true,
                    middleContent: [
                        <>
                            <BudgetSelector
                                className="budgetSelector_Shared_TikTok"
                            />
                            <DatesCampaign
                                className="datesCampaign_Shared_TikTok"
                            />
                            <RunningForCard
                                className="runningForCard_Shared_TikTok"
                                disableMobileButton={false}
                                finishFlow={() => { }}
                                targetingType="all"
                                geographyType="all"
                            />
                        </>
                    ],
                },
                {
                    title: PlaybookStepName.TARGETING,
                    name: PlaybookStepName.TARGETING,
                    isNoBackground: true,
                    middleContent: [
                        <TargetingCampaignViewSummary
                            className="targetingCampaignViewAudiences_Shared_TikTok"
                            platform="tiktok"
                        />,
                    ],
                    // rightSideContent: {
                    //     title: "Your ads will target these audiences:",
                    //     component: <TargetingCampaignView_PREVIEW
                    //         className="targetingCampaignViewPreview_GrowPlaylistFollowers"
                    //         platform="facebook"
                    //     />
                    // }
                },
                {
                    title: PlaybookStepName.FINALIZATION,
                    name: PlaybookStepName.FINALIZATION,
                    middleContent: [
                        <FinalizationCampaignView
                            className="finalizationCampaignView_Shared_TikTok"
                            variant="tiktok"
                        />,
                        <SubmitOrCheckoutButtonsView />
                    ]
                }
            ]
        }
    };

    const makePlaybook = () => {
        const playbookTypeInfo = PLAYBOOK_TYPE_INFO_WITH_PLAYBOOK_STEPS.find(item => item.playbookType === playbookType);
        if (!playbookTypeInfo) {
            return null;
        }

        const {
            title,
            description,
            adPlatform,
            entryPoint,
            connectionsMiddleContent,
            creativeMiddleContent,
        } = playbookTypeInfo;

        const PLAYBOOK_SHARED_FLOWS = AD_PLATFORM_SHARED_PLAYBOOK_STEPS[adPlatform];
        if (!PLAYBOOK_SHARED_FLOWS) {
            return null;
        }

        let playbookSteps: PlaybookStep[] = [];
        if (entryPoint) {
            playbookSteps.push(entryPoint);
        }

        // Create a copy of shared steps
        const sharedPlaybookSteps = [...PLAYBOOK_SHARED_FLOWS.sharedSteps];

        // If creativeMiddleContent exists, update or add the CREATIVE step
        if (creativeMiddleContent) {
            const creativeStepIndex = sharedPlaybookSteps.findIndex(step => step.name === PlaybookStepName.CREATIVE);

            // If the CREATIVE step exists, update it
            if (creativeStepIndex >= 0) {
                sharedPlaybookSteps[creativeStepIndex] = {
                    ...sharedPlaybookSteps[creativeStepIndex],
                    middleContent: creativeMiddleContent as React.ReactElement[],
                };
            }
        }

        // If connectionsMiddleContent exists, update or add the CONNECTIONS step
        if (connectionsMiddleContent) {
            const connectionsStepIndex = sharedPlaybookSteps.findIndex(step => step.name === PlaybookStepName.CONNECTIONS);

            // If the CONNECTIONS step exists, update it
            if (connectionsStepIndex >= 0) {
                sharedPlaybookSteps[connectionsStepIndex] = {
                    ...sharedPlaybookSteps[connectionsStepIndex],
                    middleContent: connectionsMiddleContent as React.ReactElement[],
                };
            }
        }

        playbookSteps.push(...sharedPlaybookSteps);

        const newPlaybook: Playbook = {
            title,
            description,
            steps: playbookSteps,
            adPlatform,
        };

        return newPlaybook;
    }

    const playbook = makePlaybook();

    useEffect(() => {
        return () => {
            resetCampaignState();
        }
    }, []);

    useEffect(() => {
        if (playbook && !playbookInitialized && campaignInitialized) {
            // Debug logging to see what's happening with the playbook steps
            const playbookStepNamesLocal = playbook.steps.map(step => step.name) || [];

            let currentStep: PlaybookStepName = defaultStep || playbookStepNamesLocal[0];
            if (defaultsToLastStep) {
                currentStep = playbookStepNamesLocal[playbookStepNamesLocal.length - 1];
            }
            if (defaultsToFirstStep) {
                currentStep = playbookStepNamesLocal[0];
            }

            setCurrentStep(currentStep);
            setPlaybookStepNames(playbookStepNamesLocal);
            setPlaybookInitialized(true);
        }
    }, [playbook]);

    // Add debugging for playbookStepNames
    // useEffect(() => {

    //     // Check after a delay to see if state was updated correctly
    //     setTimeout(() => {
    //     }, 500);
    // }, [playbookStepNames]);


    // Simplify useEffect to avoid duplicate campaign initialization
    // useEffect(() => {

    //     // Only set the current step if needed
    //     if (playbook?.steps[0]?.title && currentStep !== playbook.steps[0].title) {
    //         setCurrentStep(playbook.steps[0].title as PlaybookStepName);
    //     }

    //     return () => {
    //         resetCampaignState();
    //     };
    // }, [playbook, currentStep, resetCampaignState]);

    // Set playbook steps when playbook changes
    // useEffect(() => {
    //     if (!playbook) return;

    //     const stepTitles = playbook.steps.map((step: PlaybookStep) => step?.title).filter((title): title is PlaybookStepName => !!title);
    //     if (stepTitles && stepTitles.length > 0) {
    //         setPlaybookSteps(playbook.steps.filter((step): step is PlaybookStep => !!step) || []);
    //     }
    // }, [playbook, setPlaybookSteps]);

    const isShowMeHowButton = () => {
        const currentStepData = playbook?.steps.find(step => step?.title === currentStep);
        if (currentStepData?.rightSideContent) {
            return true;
        }

        return false;
    }

    // Update tab change handler to modify URL and update state
    const handleTabChange = (tab: TabItem) => {
        if (!currentStep) {
            return;
        }

        const newStep = tab.id as PlaybookStepName;
        const currentStepIndex = playbookStepNames.indexOf(currentStep);
        const newStepIndex = playbookStepNames.indexOf(newStep);

        // Only allow going backwards in steps
        if (newStepIndex > currentStepIndex) {
            return;
        }

        setCurrentStep(newStep);

        // Update URL without full page reload
        // history.push({
        //     pathname: location.pathname,
        //     search: `?tab=${newStep}`
        // });
    }

    if (!playbook) {
        return null;
    }

    const getPlaybookTitle = () => {
        return playbook?.title ?? 'Campaign Playbook';
    }

    const renderLeftSideContent = (leftSideContent: PlaybookStep['leftSideContent']) => {
        if (!leftSideContent || !leftSideContent.component) {
            return null
        }

        const {
            title,
            component
        } = leftSideContent || {};

        if (mobileView) {
            return null
        }

        return (
            <div
                className="leftSideContentStyle"
                style={styx(
                    mStyle(sty, 'leftSideContentStyle'),
                    { visibility: !leftSideContent ? 'hidden' : 'visible' }
                )}
            >
                {title &&
                    <div
                        className="leftSideContentTitle"
                        style={sty.leftSideContentTitle}
                    >
                        {title}
                    </div>
                }
                {component}
            </div>
        )
    }

    const renderRightSideContent = (rightSideContent: PlaybookStep['rightSideContent']) => {
        if (!rightSideContent) {
            return null;
        }

        const {
            title,
            component
        } = rightSideContent || {};

        return (
            <div
                className="rightSideContentStyle"
                style={styx(
                    mStyle(sty, 'rightSideContentStyle'),
                    { visibility: !rightSideContent ? 'hidden' : 'visible' }
                )}
            >
                {title &&
                    <div
                        className="rightSideContentTitle"
                        style={sty.rightSideContentTitle}
                    >
                        {title}
                    </div>
                }
                {component}
            </div>
        )
    }

    const renderPlaybookStepMiddleContent = (step: PlaybookStep) => {
        const { middleContent, isNoBackground } = step;
        return (
            <div
                className="stepMiddleContentView"
                style={styx(
                    mStyle(sty, 'stepMiddleContentView'),
                    isNoBackground ? { backgroundColor: 'none', padding: 0 } : null
                )}
            >
                {middleContent.map((component, index) => (
                    <Fragment key={index}>
                        {component}
                    </Fragment>
                ))}
            </div>
        )
    }

    const renderPlaybookStepTabs = () => {
        const isShowMeHowButtonHeight = mobileView && isShowMeHowButton() ? CAMPAIGN_VIEW_EXTRA_MODAL_HEIGHT : 0;
        const tabScrollHeight = mobileView ? TOP_BAR_HEADER_FOOTER_HEIGHT_MOBILE : TOP_BAR_HEADER_FOOTER_HEIGHT;

        return playbook?.steps?.map((step: PlaybookStep, index: number) => {
            const { leftSideContent, rightSideContent } = step;
            return (
                <Fragment key={makeKey('playbook-step', step.name, index)}>
                    <TabSymphony
                        key={makeKey(step.name, index)}
                        className={clsx(
                            'tabPanelCampaignView',
                            currentStep === step.name ? "tabPanelActive" : "tabPanelInactive",
                            step.name
                        )}
                        style={styx(
                            mStyle(sty, 'tabPanelCampaignView'),
                            { height: cssCalc(tabScrollHeight + isShowMeHowButtonHeight) }
                        )}
                        visible={currentStep === step.name}
                    >
                        <div
                            className="stepContainer"
                            style={mStyle(sty, 'stepContainer')}
                        >
                            {renderLeftSideContent(leftSideContent)}
                            {renderPlaybookStepMiddleContent(step)}
                            {!mobileView && renderRightSideContent(rightSideContent)}
                        </div>

                        {/* MODALS */}
                        {currentStep === step.name && mobileView &&
                            <ModalSymphony
                                className="campaignViewModal"
                                isOpen={isShowRightSideContentModal}
                                onClose={() => setIsShowRightSideContentModal(false)}
                            >
                                <div style={{ paddingTop: 8 }}>
                                    {renderRightSideContent(rightSideContent)}
                                </div>
                            </ModalSymphony>
                        }
                    </TabSymphony>
                </Fragment>
            )
        })
    }

    const renderCampaignTabs = () => {
        const playbookTabs = playbook?.steps.map((step: PlaybookStep) => {
            return {
                id: step.name,
                title: step.title,
            };
        });

        return (
            <TabsSymphony
                className="campaignViewTabs"
                style={sty.campaignViewTabs}
                styleHeader={mobileView ? { height: WEBSITE_TOP_BAR_HEIGHT_MOBILE } : {}}
                tabs={playbookTabs}
                selectedTab={currentStep as PlaybookStepName}
                onChange={(tab) => handleTabChange(tab as TabItem)}
                type="numbers"
                isHeader
            />
        );
    };

    const isNextButtonDisabled = () => {
        switch (currentStep) {
            case PlaybookStepName.GOAL_SELECTOR:
                if (campaignGoal?.id === 'promote_a_link') {
                    return linksToPromote.length === 0 || !linksToPromote[0].isValidUrl;
                }
                return false
            case PlaybookStepName.RECORD_SELECTOR:
                return !selectedSongToPromote;
            case PlaybookStepName.CONNECTIONS:
                if (expressSetupOrCustomPages === 'express') {
                    return false
                }

                return !canRunAds;
            case PlaybookStepName.CREATIVE:
                if (playbook.adPlatform === AdPlatform.META) {
                    let allSelectedPosts = getAllSelectedPosts('facebook');
                    if (allSelectedPosts.length === 0) {
                        return true;
                    }
                } else if (playbook.adPlatform === AdPlatform.TIKTOK) {
                    let allSelectedPosts = getAllSelectedPosts('tiktok');
                    if (allSelectedPosts.length === 0) {
                        return true;
                    }
                }
                return false;
            case PlaybookStepName.BUDGET:
                if (!budget || !startDate || isBudgetTooLow) {
                    return true;
                }

                if (playbook.adPlatform === AdPlatform.TIKTOK) {
                    return parseFloat(budget) < 50;
                }

                switch (currentDateSelectionTab) {
                    case CURRENT_DATE_SELECTION_TABS.DATE_RANGE:
                        if (!endDate) {
                            return true;
                        }

                        return false;
                    case CURRENT_DATE_SELECTION_TABS.NUMBER_OF_DAYS:
                        if (!numberOfDays || numberOfDays === 0) {
                            return true;
                        }

                        return false;
                    case CURRENT_DATE_SELECTION_TABS.MAXIMUM_BUDGET:
                        if (!budgetMaximum || budgetMaximum === '0') {
                            return true;
                        }
                }

                return false;
            case PlaybookStepName.LINK_SELECTOR:
                return linksToPromote.length === 0 || !linksToPromote[0].isValidUrl;
            case PlaybookStepName.TARGETING:
                return !isGeographyBucketsObjectValid
            default:
                return false;
        }
    }

    const isNextButtonHidden = () => {
        switch (currentStep) {
            case PlaybookStepName.FINALIZATION:
                return true;
            default:
                return false;
        }
    }

    const isPrevButtonDisabled = () => {
        const currentStepIndex = playbook?.steps.findIndex(step => step.name === currentStep);
        const isFirstStep = currentStepIndex === 0;
        return isFirstStep;
    }

    const renderNavigationButtons = () => {
        // const currentStepIndex = playbook?.steps.findIndex(step => step.name === currentStep);
        // const isFirstStep = currentStepIndex === 0;
        // const isLastStep = currentStepIndex === playbook?.steps.length - 1;

        const playbookTabs = playbook?.steps.map((step: PlaybookStep) => {
            return {
                id: step.name,
                title: step.title,
            };
        });

        let title = "Show Me How"
        let showBottomBarOnMobile = false
        if (currentStep === PlaybookStepName.CREATIVE) {
            title = "View Ad Preview"
            showBottomBarOnMobile = true
        }

        return (
            <PrevNextFooter
                className="campaignViewButtonsBottom"
                style={mobileView ? { height: PREV_NEXT_FOOTER_HEIGHT_MOBILE } : {}}
                tabs={playbookTabs}
                currentTab={currentStep as PlaybookStepName}
                handlePrevTab={prevCampaignStep}
                handleNextTab={() => {
                    if (isNextButtonDisabled()) {
                        return;
                    }

                    nextCampaignStep()
                }}
                isAboveContainer={isShowMeHowButton()}
                maxWidth={CAMPAIGN_VIEW_MAX_WIDTH}
                isNextButtonHidden={isNextButtonHidden()}
                isNextButtonDisabled={isNextButtonDisabled()}
                styleAboveContainer={mobileView ? { bottom: PREV_NEXT_FOOTER_HEIGHT_MOBILE } : {}}
                aboveContainerChildren={showBottomBarOnMobile &&
                    <ButtonSymphony
                        className="campaignViewExtraModal"
                        onClick={() => setIsShowRightSideContentModal(true)}
                        variant="text"
                    >
                        {title}
                    </ButtonSymphony>
                }
            />
        )
    };

    const exitCampaignCreator = () => {
        history.push('/marketing')
    }

    const renderTopBar = () => {
        return (
            <TopBar
                className="campaignViewTopBar"
                style={mobileView ? { height: WEBSITE_TOP_BAR_HEIGHT_MOBILE } : {}}
                title={getPlaybookTitle()}
                isCloseIcon
                handleClose={exitCampaignCreator}
            />
        )
    }

    // NOTE: render()
    return (
        <div
            className={clsx('campaignViewComponent', className)}
            style={styx(
                mStyle(sty, 'campaignViewComponent'),
                // { height: cssCalc(56 + 72 + 24) }
            )}
        >
            {renderTopBar()}
            {/* <DebugBox
                alwaysShow
                data={{
                    selectedSongToPromote,
                    // campaignGoal,
                    // currentStep,
                }}
            /> */}
            {renderCampaignTabs()}
            {renderPlaybookStepTabs()}
            {renderNavigationButtons()}
        </div>
    )
};

const sty: Record<string, CSSProperties> = {
    campaignViewComponent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%',
        backgroundColor: Colors.greyLighter,
        overflow: 'hidden',
    },
    campaignViewComponent_mobile: {
        height: 'auto',
    },
    stepMiddleContentView: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: CAMPAIGN_VIEW_MAX_WIDTH,
        backgroundColor: 'white',
        borderRadius: 8,
        padding: 16,
        gap: 16,
        minHeight: 100,
        alignSelf: 'flex-start',
        minWidth: 0,
    },
    stepMiddleContentView_mobile: {
        borderRadius: 0,
        padding: 12,
        maxWidth: '100%',
    },
    stepContainer: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'row',
        gap: 16,
        width: '100%',
    },
    stepContainer_mobile: {
        flexDirection: 'column-reverse',
    },
    tabPanelCampaignView: {
        display: 'flex',
        flexDirection: 'column',
        padding: 16,
        width: '100%',
        overflowY: 'scroll',
    },
    tabPanelCampaignView_mobile: {
        padding: 0,
    },
    campaignButtonsBottom: {
        position: 'fixed',
        width: '100%',
        bottom: 0,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: 0,
        height: CAMPAIGN_VIEW_BOTTOM_BAR_HEIGHT,
        gap: 16,
        backgroundColor: 'white',
        boxShadow: '0px -2px 8px rgba(0, 0, 0, 0.1)',
        marginTop: 'auto',
    },
    rightSideContentStyle: {
        position: 'sticky',
        width: SIDE_CONTENT_WIDTH,
        top: 0,
        backgroundColor: 'white',
        flexShrink: 0,
        borderRadius: 8,
        overflow: 'hidden',
        alignSelf: 'flex-start',
    },
    rightSideContentStyle_mobile: {
        width: '100%',
        position: 'static',
        borderRadius: 0,
    },
    rightSideContentStyle_medium: {
        width: 200,
    },
    leftSideContentStyle: {
        position: 'sticky',
        width: SIDE_CONTENT_WIDTH,
        top: 0,
        backgroundColor: 'white',
        flexShrink: 0,
        borderRadius: 8,
        padding: 16,
        overflow: 'hidden',
        alignSelf: 'flex-start',
    },
    leftSideContentStyle_mobile: {
        width: '100%',
        position: 'static',
        borderRadius: 0,
    },
    leftSideContentStyle_medium: {
        width: 200,
    },
    campaignViewTabs: {
        maxWidth: CAMPAIGN_VIEW_MAX_WIDTH + 148,
        width: '100%',
    },
    leftSideContentTitle: {
        ...Sty.text18bold,
        marginBottom: 16
    },
    rightSideContentTitle: {
        ...Sty.text18bold,
        marginBottom: 16,
        padding: 16,
    },
}

export default CampaignView;
